module.exports = __webpack_public_path__ + "fonts/regular.322448bd.woff";